export const CRON_PRESETS = [
  { label: "Every hour", cron: "0 * * * *" },
  { label: "Every 6 hours", cron: "0 */6 * * *" },
  { label: "Daily", cron: "0 0 * * *" },
  { label: "Weekly", cron: "0 0 * * 0" },
] as const;

const cronToLabel = new Map<string, string>(
  CRON_PRESETS.map((p) => [p.cron, p.label]),
);

/** Returns the human-readable label for a known cron preset, or null. */
export function getCronLabel(cron: string): string | null {
  return cronToLabel.get(cron) ?? null;
}
